<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="modalData.title"
        :show-close="false"
        width="550px"
        append-to-body
        :before-close="handleClose">
        <div>
            <el-form ref="form" :model="formItem" class="pr40">
                <el-form-item label="数据时段：" prop="startTime" label-width="100px" class="label-required" style="margin-bottom: 0">
                    <el-time-select
                        style="width: 150px;"
                        placeholder="起始时间"
                        v-model="formItem.startTime"
                        :default-value="formItem.startTime"
                        @change="changeStartTime"
                        :editable="false"
                        :picker-options="{
                          start: '00:00',
                          step: '01:00',
                          end: '23:45',
                          maxTime: formItem.endTime
                        }">
                    </el-time-select>
                     <span class="ml10 mr10">-</span>
                    <el-time-select
                        style="width: 150px;"
                        placeholder="结束时间"
                        v-model="formItem.endTime"
                        :default-value="formItem.endTime"
                        :editable="false"
                        :picker-options="{
                          start: '01:00',
                          step: '01:00',
                          end: '24:00',
                          minTime: formItem.startTime
                        }">
                    </el-time-select>

                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/dataCenter.js';
    import dayjs from 'dayjs';

    export default {
        name: "TimeModal",
        components: {},
        props: {
            modalData: {
                type: Object,
                required: true,
            },
            last:[String,Object],
            condition:{
                type: Array,
                required: true,
            },
            rangeTime:{
                type: Array,
                required: true,
            },
            platId:{
                type: [String,Number],
                required: true,
            },
        },
        data() {
            let _this = this;
            return {
                dialogVisible: false,
                formItem: {
                    startTime: '',
                    endTime: '',
                },
                dateAllDisabled:true,
                startDate:'',
                endDate:'',
                notHasCostDate:[],

            }
        },
        computed: {},
        mounted(){
            $('body').on('mouseover','.td-empty-date-start-modal-1',function(e){
                let $target = $(e.target);
                $target.attr('title', '根据选择的条件该日期无开户日期');
            })
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.$emit('close',this.modalData);
                this.resetForm();
            },
            resetForm() {
                this.formItem.startTime = '';
                this.formItem.endTime = '';
                this.$refs.form.resetFields();
            },
            showModal() {
                this.dialogVisible = true;
                console.log('showModal1',this.modalData.timeValue);

                this.$nextTick(()=>{
                    let timeValue = this.modalData.timeValue||[];

                    if(timeValue.length>0){
                        this.$set(this.formItem,'startTime', timeValue[0]);
                        this.$set(this.formItem,'endTime', timeValue[1]);
                    }else{
                        this.$set(this.formItem,'startTime', '00:00');
                        this.$set(this.formItem,'endTime', new Date().getHours()+':00');
                    }
                })
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if(!this.formItem.startTime){
                            return this.$message.error('请选择开始时间');
                        }
                        if(!this.formItem.endTime){
                            return this.$message.error('请选择结束时间');
                        }
                        this.$emit('save-value',this.modalData,[this.formItem.startTime,this.formItem.endTime],'time');
                        this.handleClose();
                    } else {
                        return false;
                    }
                });
            },
            changeStartTime(val){
                // this.formItem.endTime = '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body {
        padding: 20px;
    }

</style>
